import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=44157f7d&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44157f7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44157f7d')) {
      api.createRecord('44157f7d', component.options)
    } else {
      api.reload('44157f7d', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=44157f7d&scoped=true&", function () {
      api.rerender('44157f7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ga8o4zVvNt5H/JS/comp/SearchFilterTokens.vue"
export default component.exports